"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberRangeInput = void 0;
const react_1 = __importStar(require("react"));
const base_range_input_1 = require("./base-range-input");
require("./range-input.types");
const utils_1 = require("./utils");
const numberFormatter = (digitFraction) => (0, utils_1.pipe)(utils_1.normalizeNumber, (0, utils_1.formatNumber)(digitFraction));
const numberParser = (digitFraction) => (0, utils_1.pipe)(utils_1.normalizeNumber, (0, utils_1.fractionTakeUntill)(digitFraction));
const NumberRangeInput = (_a) => {
    var { digitFraction = 0, parser, formatter, currency } = _a, props = __rest(_a, ["digitFraction", "parser", "formatter", "currency"]);
    const internalParser = (0, react_1.useCallback)((value) => {
        const trimmed = value.trim();
        const prepared = trimmed
            ? parseFloat(numberParser(digitFraction)(trimmed))
            : NaN;
        return parser ? parser(prepared.toString()) : prepared;
    }, [parser, digitFraction]);
    const internalFormatter = (0, react_1.useCallback)((value) => {
        var _a;
        if (!value)
            value = (_a = `${props.value}`) !== null && _a !== void 0 ? _a : '';
        const trimmed = value.trim();
        const prepared = trimmed
            ? numberFormatter(digitFraction)(trimmed)
            : trimmed;
        return formatter ? formatter(prepared) : prepared;
    }, [formatter, digitFraction, props.value]);
    const inputMode = (0, react_1.useMemo)(() => (digitFraction ? 'decimal' : 'numeric'), [digitFraction]);
    return (react_1.default.createElement(base_range_input_1.BaseRangeInput, Object.assign({}, props, { currency: currency, formatter: internalFormatter, parser: internalParser, inputMode: inputMode })));
};
exports.NumberRangeInput = NumberRangeInput;
